import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {MyReports} from './MyReports';
import {fetchReports, resetMyReportsAction, updateReportAction} from './store/my-reports.actions';
import {getEntitiesAsList, getPendingReports} from './store/my-reports.selectors';
import {createEventStreamListener} from '../../service/eventStream';
import {handleRoutingError} from '../../store/_common/actions';
import {Api} from '../../settings';
import PropTypes from "prop-types";

export const MyReportsProvider = ({error, report: reportId, shouldStayAlive, reports, actions, loading, searchTerm, user}) => {

  useEffect(() => {
    actions.fetchReports();
    const evtStream = createEventStreamListener({
      eventPath: Api.reportEventStream(user.email),
      shouldStayAlive,
      dispatch: actions.updateReport
    });

    if (error) actions.handlerRoutingError(error, reportId);

    return () => {
      evtStream.close();
      actions.resetMyReports();
    }
  }, []);

  const data = React.useMemo(
    () => ({reports, loading, actions, searching: searchTerm, user}),
    [reports, loading, actions, searchTerm, user],
  );

  return (
    <MyReports {...data}/>
  );
};

const mapStateToProps = (state) => ({
  reports: getEntitiesAsList(state),
  shouldStayAlive: getPendingReports(state),
  searchTerm: state.myReportsReducers.searchTerm,
  loading: state.myReportsReducers.loading,
  user: state.authReducers.user,
});

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      fetchReports: (payload) => dispatch(fetchReports(payload)),
      updateReport: (payload) => dispatch(updateReportAction(payload)),
      handlerRoutingError: (error, report) => dispatch(handleRoutingError(error, report)),
      resetMyReports: (payload) => dispatch(resetMyReportsAction(payload))
    },
    dispatch
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(MyReportsProvider);

MyReportsProvider.propTypes = {
  error: PropTypes.string,
  report: PropTypes.string,
  actions: PropTypes.object,
  dispatch: PropTypes.func,
  reports: PropTypes.array,
  shouldStayAlive: PropTypes.bool,
  searchTerm: PropTypes.string,
  loading: PropTypes.bool,
  user: PropTypes.object
};
